import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Create axios instance with auth token
const createAuthAxios = () => {
  const token = localStorage.getItem('token');
  return axios.create({
    baseURL: API_URL,
    headers: {
      'Authorization': token ? `Bearer ${token}` : ''
    }
  });
};

const userService = {
  // Get all users
  getAllUsers: async () => {
    const authAxios = createAuthAxios();
    return authAxios.get('/users');
  },

  // Toggle admin status
  toggleAdminStatus: async (userId) => {
    const authAxios = createAuthAxios();
    return authAxios.patch(`/users/${userId}/admin`);
  },

  // Add points to user
  addPointsToUser: async (userId, points, reason) => {
    const authAxios = createAuthAxios();
    return authAxios.post(`/users/${userId}/points`, { points, reason });
  },

  // Delete user
  deleteUser: async (userId) => {
    const authAxios = createAuthAxios();
    return authAxios.delete(`/users/${userId}`);
  }
};

export default userService;
